import { ReactElement, ReactNode, useState } from "react"
import { v4 as uuid4 } from "uuid"

import CreateV2GBundleProvider from "./baseProviders/createV2GBundleProvider"

interface IPublishV2GBundleProviderProps {
    children: ReactNode
}

const PublishV2GBundleProvider = ({
    children,
}: IPublishV2GBundleProviderProps): ReactElement => {
    const [evacAttachmentUUID] = useState<string>(uuid4())

    return (
        <CreateV2GBundleProvider evacAttachmentUUID={evacAttachmentUUID}>
            {children}
        </CreateV2GBundleProvider>
    )
}

export default PublishV2GBundleProvider
